import { authMiddleware } from "react-relay-network-modern";
import { supabase } from "./supabase-client";

export const JwtMiddleware = authMiddleware({
	allowEmptyToken: true,
	token: async () => {
		const {
			data: { session },
		} = await supabase.auth.getSession();
		return session?.access_token || "";
	},
});
